export class UserViewPermissions {
  create = false;
  read = true;
  update = false;
  delete = false;
  archive = false;
  unarchive = false;
  invite = false;
}
